module.exports = __webpack_public_path__ + "img/logo6.2ec88324.png";